import { cssJoin } from '@volvo-cars/css/utils';

import styles from './List.module.css';

type ListVariant = 'ol' | 'ul';

const List: React.FC<{
  as: ListVariant;
  children: React.ReactNode;
}> = ({ as, ...props }) => {
  const classes = cssJoin(styles.list, styles[as]);

  if (as === 'ol') {
    return <ol className={classes} {...props} />;
  } else {
    return <ul className={classes} {...props} />;
  }
};

export default List;
